import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AppShell from './components/AppShell';
import AdminOverview from './pages/AdminOverview';
import AllRequisitions from './pages/AllRequisitions';
import RequisitionDetail from './pages/RequisitionDetail';
import Reports from './pages/Reports';
import ItemMaster from './pages/ItemMaster';
import EBOMaster from './pages/EBOMaster';
import BrandMaster from './pages/BrandMaster';
import SalesData from './pages/SalesData';
import StockMaster from './pages/StockMaster';
import OrderChecks from './pages/OrderChecks';
import Automailer from './pages/Automailer';
import PortalSettings from './pages/PortalSettings';
import UsersRoles from './pages/UsersRoles';
import EBODashboard from './pages/EBODashboard';
import RaiseRequisition from './pages/RaiseRequisition';
import MyRequisitions from './pages/MyRequisitions';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const RoleHome = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'EBO') return <Navigate to="/app/dashboard" replace />;
  return <Navigate to="/app/overview" replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleHome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
            <Route path="overview" element={<AdminOverview />} />
            <Route path="requisitions" element={<AllRequisitions />} />
            <Route path="requisitions/:id" element={<RequisitionDetail />} />
            <Route path="reports" element={<Reports />} />
            <Route path="items" element={<ItemMaster />} />
            <Route path="ebos" element={<EBOMaster />} />
            <Route path="brands" element={<BrandMaster />} />
            <Route path="sales" element={<SalesData />} />
            <Route path="stock" element={<StockMaster />} />
            <Route path="order-checks" element={<OrderChecks />} />
            <Route path="automailer" element={<Automailer />} />
            <Route path="settings" element={<PortalSettings />} />
            <Route path="users" element={<UsersRoles />} />
            <Route path="dashboard" element={<EBODashboard />} />
            <Route path="raise" element={<RaiseRequisition />} />
            <Route path="my-requisitions" element={<MyRequisitions />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
